export const FareCalculator = (drp,pck,distance,time,rateDetails,instructionData, decimal)=>{  

    let baseCalculated =  (parseFloat(rateDetails.rate_per_unit_distance) * parseFloat(distance)) + (parseFloat(rateDetails.rate_per_hour) * (parseFloat(time) / 3600));
    if(rateDetails.base_fare>0){
        baseCalculated = baseCalculated + rateDetails.base_fare;
    }
    if(instructionData && instructionData.parcelTypeSelected){
        baseCalculated = baseCalculated + instructionData.parcelTypeSelected.amount;
    }
    if(instructionData && instructionData.optionSelected){
        baseCalculated = baseCalculated + instructionData.optionSelected.amount;
    }
    let total = baseCalculated > parseFloat(rateDetails.min_fare) ? baseCalculated : parseFloat(rateDetails.min_fare);
    let convenienceFee = 0;

    let airportFees = ((drp && drp.toLowerCase().includes("airport")) || (pck && pck.toLowerCase().includes("airport"))) ? parseFloat(rateDetails.airport_fees) : 0;

    //console.log(rateDetails.airport_fees);
    if(rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat'){
        convenienceFee = rateDetails.convenience_fees;
    }else{
        convenienceFee = (total*parseFloat(rateDetails.convenience_fees)/100);
    }

//    console.log('baseCalculated: ', baseCalculated, '(distance): ', parseFloat(distance), '(time): ', parseFloat(time), parseFloat(rateDetails.rate_per_unit_distance), parseFloat(rateDetails.rate_per_hour), (parseFloat(time) / 3600));

    let bf = rateDetails.base_fare || 0;
    let df = (parseFloat(rateDetails.rate_per_unit_distance) * parseFloat(distance));
    let tf = (parseFloat(rateDetails.rate_per_hour) * (parseFloat(time) / 3600));
    let mf = rateDetails.min_fare || 0;
    let driverfareTotal = total + airportFees;
    let driverfareGST = (driverfareTotal*parseFloat(rateDetails.gst_tax)/100);
    let platformFee = convenienceFee;
    let platformFeeGST = (platformFee*parseFloat(rateDetails.gst_tax)/100);
    let subtotalexGST = driverfareTotal + platformFee;
    let totalGST = driverfareGST + platformFeeGST;
    let grandTotal = subtotalexGST + totalGST;


//    console.log('baseCalculated: ', bf, '(distance): ', df, '(time): ', tf);



//    total = total + airportFees;
//    let grand = total + convenienceFee;
//    let gstTax = (grand*parseFloat(rateDetails.gst_tax)/100);
//    convenienceFee = convenienceFee + gstTax;
    
//    grand = total + convenienceFee;
//    console.log('drp: ', drp, 'pck: ', pck, 'total: ', total, 'airportFees: ', airportFees, 'convenienceFee: ', convenienceFee, 'totalGST: ', totalGST, 'grandTotal: ', grandTotal );

    return {

        bf:parseFloat(bf.toFixed(decimal)),
        df:parseFloat(df.toFixed(decimal)),
        tf:parseFloat(tf.toFixed(decimal)),
        mf:parseFloat(mf.toFixed(decimal)),
        driverfareTotal:parseFloat(driverfareTotal.toFixed(decimal)),
        airportFees:parseFloat(airportFees.toFixed(decimal)),
        driverfareGST:parseFloat(driverfareGST.toFixed(decimal)),
        platformFee:parseFloat(platformFee.toFixed(decimal)),
        platformFeeGST:parseFloat(platformFeeGST.toFixed(decimal)),
        subtotalexGST:parseFloat(subtotalexGST.toFixed(decimal)),
        totalGST:parseFloat(totalGST.toFixed(decimal)),
        grandTotal:parseFloat(grandTotal.toFixed(decimal))
    }
     
}
